module.exports = __webpack_public_path__ + "img/allergy-gluten.57702c4d.png";